import React from "react";
import cx from "classnames";

interface CircularTextProps {
  text: string;
  radius?: number;
  className?: string;
}

const DEFAULT_RADIUS = 100;

const CircularText: React.FC<CircularTextProps> = ({
  text,
  radius = DEFAULT_RADIUS,
  className,
}) => {
  const letters = text.split("");
  const rotationBetweenLetters = 360 / letters.length || 100;

  return (
    <div
      aria-label={text}
      className={cx(className)}
      style={{ height: `${radius * 2}px`, width: `${radius * 2}px` }}>
      {letters.map((letter, index) => {
        const rotation = index * rotationBetweenLetters;

        return (
          <p
            key={index}
            style={{
              height: `${radius}px`,
              position: "absolute",
              transform: `rotate(${rotation}deg)`,
              transformOrigin: "0 100%",
              color: "#C6C6C8",
              fontFamily:
                "Menlo, Consolas, Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace",
              fontSize: 13.275,
              fontWeight: 700,
              lineHeight: "normal",
            }}>
            {letter}
          </p>
        );
      })}
    </div>
  );
};

export default CircularText;
